import { action } from 'typesafe-actions';
import { RegisterActionTypes } from './types';
import { CustomerRegister } from '../../model/customer-register';

export const registerRequest = (customer: CustomerRegister) => action(RegisterActionTypes.REGISTER_REQUEST, customer);
export const registerSuccess = () => action(RegisterActionTypes.REGISTER_SUCCESS);
export const registerError = (message: string) => action(RegisterActionTypes.REGISTER_ERROR, message);
export const reset = () => action(RegisterActionTypes.RESET);
